import React from 'react'
import styles from './styles.css'
import StarIcon from './star.svg'
import classnames from 'classnames'
import ExpertAvatar from '../ExpertAvatar'
import { ExpertProfilePhotoFragment } from '#src/fragments/ExpertProfilePhoto.generated'

interface Props {
  expert: ExpertProfilePhotoFragment
  size?: number
  rating?: number | null
  ratingClassName?: string
}

const ExpertRatingAvatar: React.FC<Props> = ({ expert, size, rating, ratingClassName }) => {
  return (
    <div className={styles.ratingAvatar}>
      <ExpertAvatar expert={expert} size={size} />
      {rating && (
        <div className={classnames(styles.ratingContainer, ratingClassName)}>
          {rating.toFixed(1)}
          <StarIcon width={10} height={10} className={styles.ratingStar} />
        </div>
      )}
    </div>
  )
}

export default ExpertRatingAvatar
